import React, { useEffect, useState } from 'react';
import { ApiBridgeAlert } from '../../api/models';
import BridgeAlerts from './BridgeAlerts';
import { bridgeAlertApi } from '../../apis';

interface AlertProps {
  transactionId: string;
}

export const TransactionBridgeAlerts = ({ transactionId }: AlertProps) => {
  const [fetching, setFetching] = useState(false);
  const [alerts, setAlerts] = useState<ApiBridgeAlert[]>();
  const fetchAlerts = async () => {
    setFetching(true);
    const alerts = await bridgeAlertApi.findBridgeAlertsByTransactionId({
      transactionId,
    });
    setAlerts(alerts.alerts);
    setFetching(false);
  };

  useEffect(() => {
    fetchAlerts();
  }, [transactionId]);

  return (
    <BridgeAlerts
      page={0}
      size={alerts?.length || 0}
      total={alerts?.length || 0}
      loading={fetching}
      alerts={alerts || []}
      attributes={[
        { key: 'ID', sortable: false },
        { key: 'Date', sortable: false },
        { key: 'Assignee', sortable: false },
        { key: 'Status', sortable: false },
        { key: 'Actions', sortable: false },
      ]}
      onUpdate={() => fetchAlerts()}
    />
  );
};

export default TransactionBridgeAlerts;
